<template>
  <div class="bg-genialguard">
    <div class="container text-white">
      <div class="py-5 text-center">
        <img class="d-block mx-auto mb-2 genialguard-logo" src="@/assets/logo_genial_guard.png">
        <h2>Planos GenialGuard</h2>
      </div>

      <div class="text-center" v-if="loading">
        <b-spinner class="text-white" variant="primary" label="Spinning"></b-spinner>
        <h6 class="mb-0 mt-2 font-weight-bold">Carregando planos...</h6>
      </div>

      <div class="text-center" v-else-if="plans.length === 0">
        <h6 class="mb-0 mt-2 font-weight-bold text-white">
          {{ error ? 'Erro ao carregar planos' : 'Nenhum plano disponível no momento' }}
        </h6>
        <p class="text-white-50">Tente novamente mais tarde.</p>
        <button v-if="error" class="btn btn-outline-light mt-2" @click="fetchPlans">
          Tentar novamente
        </button>
      </div>

      <div class="row" v-else>
        <div class="col-12 d-flex justify-content-center flex-nowrap align-items-end mb-4">
          <div class="d-flex flex-column">
            <button class="bg-custom-genialguard-blue border-0 outline-none px-3 pb-2 text-selected">Planos Anuais</button>
            <div class="border-selected"></div>
          </div>
        </div>

        <div class="container plans-header row">
            <div class="col-3 bg-light-blue d-flex flex-column px-4 py-2 text-white mobile-class">
              <p class="mt-4 mb-2 font-weight-bold text-12">🔐 Genial Guard</p>
              <p class="text-12 mb-3">Sua identidade profissional, protegida.</p>
              <p class="text-12 mb-3">Evite golpes, valide sua OAB com foto e envie mensagens seguras aos seus clientes com protocolo e rastreabilidade.</p>
              <p class="text-12 mb-2">Confiança para quem envia.</p>
              <p class="text-12 mb-3">Segurança para quem recebe.</p>
              
              <div class="my-2">
                <span class="font-weight-bold text-uppercase text-12">✅ Segurança jurídica</span>
              </div>
              <div class="my-2">
                <span class="font-weight-bold text-uppercase text-12">✅ Validação de identidade</span>
              </div>
              <div class="my-2">
                <span class="font-weight-bold text-uppercase text-12">✅ Reputação profissional fortalecida</span>
              </div>
              
              <button class="btn btn-sm btn-outline-light mt-3" @click="showDetails = true">
                Mais detalhes
              </button>
            </div>
            
            <div class="d-flex col-9 p-0 mobile-class flex-wrap">
              <div 
                class="plan-card d-flex flex-column px-4 py-2 mobile-plan-card position-relative bg-white mobile-class" 
                :class="{ 'col-12': plans.length === 1, 'col-6': plans.length === 2, 'col-4': plans.length === 3 }"
                v-for="plan of plans" :key="plan.id"
              >
                <div class="d-flex flex-column">
                  <div>
                    <p class="text-16 font-weight-bold py-3 text-uppercase text-orange text-center">{{plan.name}}</p>
                    <p class="text-12 text-dark-blue text-center mb-2">{{plan.description}}</p>
                    <p class="text-12 text-dark-blue text-center mb-2" v-if="plan.limites">
                      <strong>{{plan.limites.descricao}}</strong>
                    </p>
                  </div>
                  
                  <p class="unavailable-plan-badge" v-if="!plan.available">Indísponivel</p>

                  <div :class="{ 'm-auto': plans.length === 1 }">
                    <p class="text-16 text-dark-blue font-weight-bold" v-if="plan.monthlyValue && plan.available">
                      12x de R$ <span class="text-32">{{ formatPrice(plan.monthlyValue) }}</span>
                    </p>
                    <p class="yearly-total-value-installments" v-if="plan.yearlyValue && plan.available">
                      (R$ {{ formatPrice(plan.yearlyValue) }}/ano)
                    </p>
                  </div>
                  
                  <div class="mt-1" :class="{ 'm-auto pl-5':plans.length === 1 }">
                    <div class="plan-benefits mt-1" v-for="item of plan.items" :key="item">
                      <svg width="12" height="10" viewBox="0 0 12 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M1 4.5L4.5 8L11 1.5" stroke="#363F5E" stroke-width="1.5"></path>
                      </svg>
                      <span class="text-12 text-light-gray">{{ item }}</span>
                    </div>
                  </div>
                  
                  <button 
                    class="new-buy-btn" 
                    :class="{ 'btn-ghost-dark-blue': plan.available, 'btn-ghost-dark-blue-unavailable': !plan.available }"
                    :disabled="!plan.available"
                    @click="register(plan)"
                  > 
                    {{ !plan.available ? 'Indísponivel' : 'Comprar Agora' }} 
                  </button>
                    
                  <span class="warranty-text" v-if="plan.guarantee">{{ plan.guarantee }} de garantia</span>
                  <p class="text-12 text-dark-blue text-center mt-2">{{plan.ideal}}</p>
                </div>

                <div class="border-top mt-2 pt-2"></div>
              </div>
            </div>
        </div>
      </div>

      <div>
        <b-modal id="modal-1" title="TERMOS DE USO DOS SERVIÇOS ORIENTA LEGAL LTDA.">
          <TermsAndConditions />
        </b-modal>
        
        <b-modal v-model="showDetails" title="🔒 O que é o Genial Guard?" size="lg" hide-footer>
          <div class="text-dark">
            <p>O <strong>Genial Guard</strong> é uma plataforma de segurança digital que protege a comunicação entre advogados e seus clientes.</p>
            <p>Com ele, você garante que toda mensagem enviada seja autêntica, rastreável e validada — evitando golpes, fraudes e falsos contatos.</p>
            <p>A cada envio, o cliente recebe um código único de verificação e acessa uma interface protegida com nome, número da OAB, documentos validados e a mensagem original do advogado.</p>
            
            <h6 class="mt-4 mb-2">Além disso, o Genial Guard oferece:</h6>
            <ul>
              <li>Registro automático de leitura e envio</li>
              <li>Validação documental com selfie e carteira da OAB</li>
              <li>Painel de gestão para sociedades e escritórios</li>
              <li>Opções de disparo manual e automático com histórico</li>
            </ul>
            
            <div class="mt-3">
              <p>✅ Segurança jurídica</p>
              <p>✅ Validação de identidade</p>
              <p>✅ Reputação profissional fortalecida</p>
            </div>
          </div>
          
          <template #modal-footer>

          </template>
        </b-modal>
      </div>

      <Footer />
    </div>
  </div>
</template>

<script>
import Footer from 'components/Footer';
import TermsAndConditions from 'components/TermsAndConditions';
import { mapGetters } from 'vuex';
import { getGenialGuardPlans } from '@/services/genialGuard';

export default {
  name: 'GenialGuardPlans',
  components: {
    Footer,
    TermsAndConditions,
  },
  data() {
    return {
      loading: false,
      error: false,
      tab: 'anual',
      plans: [],
      showDetails: false,
      planOrder: {
        'Individual': 1,
        'Sociedade': 2,
        'Escritório': 3
      }
    };
  },
  created() {
    this.fetchPlans();
  },
  computed: {
    ...mapGetters(['authstatus', 'authErrorMessage'])
  },
  methods: {
    async fetchPlans() {
      this.loading = true;

      try {
        const response = await getGenialGuardPlans();

        console.log('getGenialGuardPlans response', response);
        
        if (response.sucesso && response.dados) {
          this.plans = response.dados.map(plan => {
            return {
              id: plan._id,
              name: plan.nome,
              description: plan.descricao,
              monthlyValue: plan.precoMensal?.toString() || '',
              yearlyValue: plan.precoAnual?.toString() || '',
              items: plan.recursos.map(recurso => recurso.nome),
              guarantee: '',
              ideal: plan.destaque || '',
              available: true,
              period: 'yearly',
              limites: plan.limites,
              publicoAlvo: plan.publicoAlvo,
              exemploParcelas: plan.exemploParcelas
            };
          });
        } else {
          console.error('Error fetching plans:', response);
          this.plans = [];
          this.error = true;
        }
      } catch (error) {
        console.error('Error fetching Genial Guard plans:', error);
        this.plans = [];
        this.error = true;
      } finally {
        this.loading = false;
      }
    },
    register(plan) {
      this.$router.push({ name: 'GenialGuardRegister', params: { plan }}); 
    },
    formatPrice(value) {
      if (!value) return '0,00';
      
      const numValue = typeof value === 'string' ? parseFloat(value) : value;
      const nf = new Intl.NumberFormat('pt-BR', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
      return nf.format(numValue);
    },
    formatMoney(value, digits) {
      const d = digits !== undefined ? digits : 2;
      const nf = new Intl.NumberFormat('pt-BR', {
        minimumFractionDigits: d,
        maximumFractionDigits: d,
      });
      return nf.format(value);
    },
  },
}
</script>

<style>

@media screen and (max-width: 768px) {
  .mobile-class {
    flex: 0 0 100% !important;
    max-width: 100% !important;
  }
}

.single-price {
  text-align: center;
  background: #ed7b02;
  transition: .7s;
  margin-top: 20px;
}

.single-price h3 {
  font-size: 25px;
  color: #000;
  font-weight: 600;
  text-align: center;
  margin: 0;
  margin-top: -80px;
  font-family: poppins;
  color: #fff;
}

.single-price h4 {
  font-size: 48px;
  font-weight: 500;
  color: #fff;
}

.single-price h4 span.sup {
  vertical-align: text-top;
  font-size: 25px;
}

.deal-top {
  position: relative;
  background: #262626 !important;
  font-size: 16px;
  text-transform: uppercase;
  padding: 136px 24px 0;
}

.deal-top::after {
  content: "";
  position: absolute;
  left: 0;
  bottom: -50px;
  width: 0;
  height: 0;
  border-top: 50px solid #262626;
  border-left: 175px solid transparent;
  border-right: 170px solid transparent;
}

.deal-bottom {
  padding: 56px 16px 0;
}

.deal-bottom ul {
  margin: 0;
  padding: 0;
}

.deal-bottom ul li {
  font-size: 16px;
  color: black;
  font-weight: 300;
  margin-top: 16px;
  border-top: 1px solid #E4E4E4;
  padding-top: 16px;
  list-style: none;
}

.btn-area a {
  display: inline-block;
  font-size: 18px;
  color: #fff;
  background: #ed7b02;
  padding: 8px 64px;
  margin-top: 32px;
  border-radius: 4px;
  margin-bottom: 40px;
  text-transform: uppercase;
  font-weight: bold;
  text-decoration: none;
}


.single-price:hover {
  background: #ed7b02;
}

.single-price:hover .deal-top {
  background: #262626;
}

.single-price:hover .deal-top:after {
  border-top: 50px solid #262626;
}

.single-price:hover .btn-area a {
  background: #262626;
}

/* ignore the code below */
.link-area {
  position: fixed;
  bottom: 20px;
  left: 20px;
  padding: 15px;
  border-radius: 40px;
  background: tomato;
}

.link-area a {
  text-decoration: none;
  color: #fff;
  font-size: 25px;
}

.text-selected {
  color: #ed7b02;
  font-weight: 700;
}

.text-unselected {
  font-weight: 700;
}

.border-selected {
  width: 100%;
  height: 3px;
  background-color: #3F87F5;
}

.border-unselected {
  width: 100%;
  height: 3px;
  background-color: rgb(108, 117, 125, 0.16);
}

.bg-custom-genialguard-blue {
  background-color: #0E1B2B;
}

.balloon {
    display: inline-block;
    background-color: #DCF5E6;
    color: #18A450;
    padding: 5px 10px;
    border-radius: 10px;
    position: relative;
    font-weight: 900;
    font-size: 12px;
    text-align: center;
    margin-bottom: 7px;
}

.bg-light-blue {
    background-color: #3F87F5;
}

.text-12 {
    font-size: .75rem !important;
}

.text-16 {
    font-size: 1em !important;
    line-height: 1.3 !important;
    font-weight: 400;
}

.text-24 {
  font-size: 1.5rem !important;
}

.text-32 {
    font-size: 32px;
    line-height: 40px;
}

.text-orange {
  color: #ed7b02;
}

.text-dark-blue {
    color: #363f5e;
}

.plan-card {
    border-left: 3px solid #D9D9D9;
}

.popular-plan-badge {
    color: #FFFFFF;
    font-weight: 700;
    font-size: 12px;
    text-align: center;
    background-color: #3F87F5;
    padding: 1px 5px;
}

.unavailable-plan-badge {
  color: #FFFFFF;
    font-weight: 700;
    font-size: 12px;
    text-align: center;
    background-color: rgb(255, 60, 60);
    padding: 6px 32px;
}

.text-light-gray {
    color: #999999;
}

.discounted-value-monthly {
  width: 78%;
  position: relative;
  border-top: 2px solid red;
  top: 13%;
}

.discounted-value-pix {
  width: 78%;
  position: relative;
  border-top: 2px solid red;
  top: 5%;
}

.discounted-value {
    color: #999999;
    text-decoration: line-through red;
    font-weight: 700;
}

.yearly-total-value-installments {
    color: #999999;
    font-size: 11px;
    font-weight: 600;
}

.plan-benefits {
    display: flex;
    align-items: center;
    column-gap: 0.7rem;
}

.btn-ghost-dark-blue {
    background-color: #363F5E;
    border: 3px solid #363F5E;
    border-radius: 4px;
    text-transform: uppercase;
    color: #FFF;
    font-weight: 800;
    padding: 10px 20px;
    margin-top: 30px;
}

.btn-ghost-dark-blue-unavailable {
    background-color: white;
    border: 3px solid #363F5E;
    border-radius: 4px;
    text-transform: uppercase;
    color: #363F5E;
    font-weight: 800;
    padding: 10px 20px;
    margin-top: 30px;
}

.btn {
    display: inline-block;
    font-weight: 400;
    color: #212529;
    text-align: center;
    vertical-align: middle;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    background-color: transparent;
    border: 1px solid transparent;
    padding: .375rem .75rem;
    font-size: 1rem;
    line-height: 1.5;
    border-radius: .25rem;
    transition: color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out;
}

.warranty-text {
    color: #18A450;
    font-size: 11px;
    font-weight: 700;
    text-align: center;
    margin-top: .25rem;
}

.clients-count-select {
    border: white;
    background-color: white;
    color: #3B424D;
    font-weight: 500;
}

.text-red {
  color: red;
}

.genialguard-logo {
  width: 180px;
  height: auto;
}

.bg-genialguard {
  background: #0E1B2B !important;
}

</style> 